import Footer from "./Component/Footer";
import MenuBar from "./Component/MenuBar";
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
import ModernEventCard from './Component/ModernEventCard';
import SectionHeading from './Component/SectionHeading';
import OurEventData from './Component/OurEventData';
import './Component/ModernEventsPage.css';



const OurEvent = () => {

    // Fetch events from API - COMMENTED OUT TO USE STATIC DATA
    // const { events: apiEvents, loading, error } = useLatestEvents('yugalkunj');

    // Use API events if available, otherwise fallback to hardcoded data
    // const eventData = apiEvents.length > 0 ? apiEvents : OurEventData;

    // Parse date from DD/MM/YYYY format
    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Set to start of today

    // Filter events to show only today and future events (hide past events)
    const upcomingEvents = OurEventData.filter(event => {
        const eventDate = parseDate(event.enddate);
        return eventDate >= currentDate;
    });

    // Sort events by date (closest dates first)
    const sortedEvents = upcomingEvents.sort((a, b) => parseDate(a.enddate) - parseDate(b.enddate));

    return (
        <>
            <MenuBar />
            <Sidebar />
            
            {/* Page Banner */}
            <PageBanner title="Upcoming Events" current="Events" />

            {/* Events Page */}
            <div className="yk-events-page">
                <div className="yk-events-container">
                    
                    {/* Page Header */}
                    <div className="yk-events-header">
                        <SectionHeading 
                            title="Upcoming Events"
                            subtitle="Discover our upcoming spiritual gatherings, festivals, and community events. Join us in celebrating devotion and building community."
                        />
                    </div>

                    {/* Events Grid */}
                    {sortedEvents.length > 0 ? (
                        <div className="yk-events-grid">
                            {sortedEvents.map((event) => (
                                <ModernEventCard key={event.id} event={event} />
                            ))}
                        </div>
                    ) : (
                        <div className="yk-events-empty">
                            <div className="yk-events-empty-icon">
                                <i className="fas fa-calendar-times"></i>
                            </div>
                            <h2 className="yk-events-empty-title">No Upcoming Events</h2>
                            <p className="yk-events-empty-text">
                                Check back soon for new events and activities!
                            </p>
                            <a href="/USA/Home" className="yk-events-empty-btn">
                                <i className="fas fa-home"></i>
                                Back to Home
                            </a>
                        </div>
                    )}

                </div>
            </div>

            <Footer />
        </>
    )




}

export default OurEvent;
